import * as uuid from 'uuid';

const { v4: uuidV4 } = uuid;

export const isStringValid = (str: string | undefined): boolean => {
  return str != undefined && (str.length == 0 || !!str.match(/^[A-Za-z]$|^([A-Za-z]+([A-Za-z0-9]|_)+$)/));
};

export const isStringValidWithoutSpecialCharacters = (str: string | undefined): boolean => {
  return str != undefined && (str.length == 0 || !str.match(/[%\/'^+%&\\]+|\s$/));
};

export const generateUUID = (): string => {
  // @ts-ignore
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) => (c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16));
};

export const generateUUIDV4 = () => {
  return uuidV4();
};

export const b64EncodeUnicode = (str: string) => {
  return btoa(
    encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
      return String.fromCharCode(parseInt(p1, 16));
    }),
  );
};

export const b64DecodeUnicode = (str: string) => {
  return decodeURIComponent(
    Array.prototype.map
      .call(atob(str), function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );
};

export default generateUUID();
